import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import { OnlyBackButton } from 'components/base/BottomStepComponent';
import ContentSections from 'components/base/ContentSections';
import CustomBreadcrumb from 'components/base/CustomBreadcrumb';
import CustomListComponent from 'components/base/CustomListComponent';
import MembershipInfoCard from 'components/customer/MembershipInfoCard';
import { pointRecordQueryKey } from 'components/pointRecord/RecordsUrlConfig';
import { POINT_RECORD_TYPE } from 'config/CustomEnums';
import { POINT_TRANSACTION_TYPE } from 'containers/record/pointRecords/PointTransactionList';
import { TRANSACTION_RECORD_TYPE } from 'containers/record/records/TransactionList';
import { createAction } from 'utils';
import LimitInfoField from 'components/limitInfo/LimitInfoField';

export const getRecordsRelatedTransactionCard = (transaction) => (
  <MembershipInfoCard
    title="Related Transaction"
    data={transaction || {}}
    fields={[
      [{
        title: 'Transaction & invoice ID',
        field: "transactionDisplayInvoiceInfo",
        deeplink: `/transactions/${transaction?.pk}/`
      }],
      [{ title: 'Transaction date', field: 'transactionDetailDisplayDate' }],
      [{ title: 'Purchase date', field: 'detailDisplayPurchaseDate' }],
      [{ title: 'Transaction value', field: 'displayPaidAmount' }],
      [{ title: 'Eligible total', field: 'displayTotalValue' }],
    ]}
  />)


function PointTransactionOverview({ selectedPointRecord }) {
  const queryString = require('query-string');
  const history = useHistory();
  const params = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: 'pointTransactionList/getSinglePointRecord',
      payload: {
        pointRecordPK: params.id,
      },
    });
    return () => dispatch(createAction("pointTransactionList/updateState")({
      selectedPointTransaction: {}
    }))
  }, [dispatch, params.id]);

  const getPointDetailSectionFieldsWithType = (pointType) => {
    let extraFields = [];
    if (pointType === 'Remove point') {
      extraFields = extraFields.concat([
        [{ title: 'Used date (optional)', field: 'useDate' }],
        [{ title: 'Used type (optional)', field: 'usedDisplayType' }],
      ]);
    }
    return [
      [{ title: 'Gift card code', field: 'giftCardCode' }],
      [{ title: 'Total points', field: 'displayTotalPoints' }],
      [{ title: 'Loyalty Point', field: 'loyaltyPoints' }],
      [{ title: 'Gift card Point', field: 'giftCardPoints' }],
      [{ title: 'Progression Points', field: 'displayDetailTpe' }],
      [{ title: 'Point source', field: 'pointSource' }],
      ...extraFields,
      [{ title: 'Remarks (optional)', field: 'remarks', isRichText: true }],
      [{ title: 'Expiry date (optional)', field: 'expiryDate' }],
    ];
  };

  const getPointsDetailSections = (record) => {
    const typeSpecialFields = getPointDetailSectionFieldsWithType(
      record.pointDisplayType,
    )
    const detailItems = [
      [{ title: 'Customer', field: 'name', customerLink: true }],
      [{ title: 'Membership ID', field: 'membershipId' }],
      [{ title: 'Event Type', field: 'pointDisplayType' }],
      [
        {
          title: 'Record Type',
          field: 'transactionDisplayType',
        },
      ],
      [{ title: 'Campaign', field: 'displayCampaignName', deeplink: selectedPointRecord?.campaignLink }],
      ...typeSpecialFields,
    ]
    const adminTypesToBeShown = [
      POINT_TRANSACTION_TYPE.MERCHANT_USE_CASH_DOLLAR,
      POINT_TRANSACTION_TYPE.ADMIN_EDITED,
      POINT_TRANSACTION_TYPE.MERCHANT_EDITED,
      POINT_TRANSACTION_TYPE.ADMIN_TRANSFERRED,
    ]
    if (adminTypesToBeShown.includes(record.transactionDisplayType)) {
      detailItems.push([
        {
          title: 'Admin User',
          field: 'displayAdministrator',
        },
      ])
    }
    detailItems.push([{ title: 'Creation date', field: 'detailDisplayCreationDate' }])
    return detailItems
  }

  const tabs = [
    {
      name: '',
      content: (
        <div className="scroll-container-common">
          <ContentSections
            sections={[
              <MembershipInfoCard
                title={'POINT RECORD DETAILS'}
                data={selectedPointRecord}
                fields={getPointsDetailSections(selectedPointRecord)}
              />,
              ...(selectedPointRecord?.transaction?.pk ? [
                getRecordsRelatedTransactionCard(selectedPointRecord.transaction)
              ] : []),
              ...selectedPointRecord?.pointsReachLimitInfo?.reachLimit
                ? [
                  <LimitInfoField
                    title="POINTS REACHED LIMIT"
                    reachLimitInfo={selectedPointRecord?.pointsReachLimitInfo}
                  />
                ]
                : [],
              ...selectedPointRecord?.ppReachLimitInfo?.reachLimit
                ? [
                  <LimitInfoField
                    title="PROGRESSION POINTS REACHED LIMIT"
                    reachLimitInfo={selectedPointRecord?.ppReachLimitInfo}
                  />
                ]
                : [],
            ]}
            hidePreview={true}
            sectionStyle="transaction-record-detail-section"
          />
        </div>
      ),
    },
  ];

  // const buttons = [
  //   <Button
  //     className="btn-further"
  //     onClick={() => {
  //       history.push(`/point_records/${selectedPointRecord.pk}/edit`);
  //     }}
  //   >
  //     Edit
  //   </Button>,
  // ];
  return (
    <>
      <CustomListComponent
        caution={{
          detail: '', //view point records
          title: 'View Point records',
        }}
        breadcrumb={<CustomBreadcrumb />}
        hideTab={true}
        tabs={tabs}
        buttons={[]}
      />
      <OnlyBackButton
        backAction={() => {
          history.push({
            pathname: '/point_records',
            search: queryString.stringify({
              [pointRecordQueryKey.page]: 1,
              [pointRecordQueryKey.rank]: true,
              [pointRecordQueryKey.searchKey]: '',
            }),
          });
        }}
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  selectedPointRecord: state.pointTransactionList.selectedPointTransaction,
});

export default connect(mapPropsToState)(PointTransactionOverview);
